export const getProps = (_, props) => props;

export default {
  getProps,
};
